import { render, staticRenderFns } from "./ConfigModelIntervene.vue?vue&type=template&id=ada3a766&"
import script from "./ConfigModelIntervene.vue?vue&type=script&lang=js&"
export * from "./ConfigModelIntervene.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModelIntervene.vue?vue&type=style&index=0&id=ada3a766&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports